/**
 *
 */

export enum WorkloadMaxType {
    peak,
    provisioned
}
